export default Object.freeze({
  MON: '월',
  TUE: '화',
  WED: '수',
  THU: '목',
  FRI: '금',
  SAT: '토',
  SUN: '일',

  TODAY: '오늘',

  MONTH: '월'
});
